import type { ReactNode } from 'react';
import { Toaster } from './ui/sonner';

interface GlobalUiShellProps {
    children: ReactNode;
}

export function GlobalUiShell({ children }: GlobalUiShellProps) {
    return (
        <>
            {children}
            <Toaster position="top-center" />
        </>
    );
}